import Vue from 'vue'
import Vuetify from 'vuetify'
import { en, es, fr } from 'vuetify/src/locale'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const options: object = {
    lang: {
        locales: { en, es, fr },
    },
    defaultAssets: false,
    icons: {
        iconfont: 'fa',
    },
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: '#1976d2',
                accent: '#424242',
                secondary: '#ff8f00',
                info: '#26a69a',
                warning: '#ffc107',
                error: '#dd2c00',
                success: '#00e676',
            },
        },
    }
}

export default new Vuetify(options)
